
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#816cc2"}},[_c('path',{attrs:{"data-name":"Эллипс 1","d":"M15 1a13.93 13.93 0 00-7.827 2.39A14.044 14.044 0 002.1 9.551a13.98 13.98 0 001.29 13.276A14.044 14.044 0 009.551 27.9a13.98 13.98 0 0013.276-1.29 14.044 14.044 0 005.073-6.16 13.98 13.98 0 00-1.29-13.277A14.044 14.044 0 0020.449 2.1 13.911 13.911 0 0015 1m0-1A15 15 0 110 15 15 15 0 0115 0z"}}),_c('path',{attrs:{"data-name":"Subtraction 143","d":"M15 27.999a13 13 0 01-13-13 13 13 0 0113-13 13 13 0 019.193 22.192A12.915 12.915 0 0115 27.999zm-4.793-13.156a.934.934 0 00-.661 1.6l2.644 2.639a.932.932 0 001.321 0l6.61-6.609a.935.935 0 00-1.321-1.322l-5.949 5.948-1.983-1.982a.93.93 0 00-.661-.274z"}})])])
          )
        }
      }
    